import * as React from 'react';
import { t } from '../../i18n';
import ForgotPasswordContainer from '../../containers/Auth/ForgotPassword';

const ForgotPasswordPage = () => {
  return (
    <>
      <div className="mb-30">
        <h1 className="mb-10">{t('auth.forgotPassword.title')}</h1>
        <p>{t('auth.forgotPassword.description')}</p>
      </div>
      <ForgotPasswordContainer />
    </>
  );
};

export default ForgotPasswordPage;
